import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import EmailModal from './EmailModal';

const Footer: React.FC = () => {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  return (
    <footer className="w-full relative px-6 md:px-16 lg:px-24 pt-20 bg-canvas">
      <div className="max-w-7xl mx-auto">
        {/* Top Separator */}
        <div className="border-t border-border"></div>

        {/* Main row: SilentLabs + Link Columns */}
        <div className="flex flex-col md:flex-row gap-16 md:gap-24 py-20">

          {/* Left: SilentLabs branding */}
          <div className="md:min-w-[200px]">
            <Link to="/" className="text-text-primary text-3xl font-medium tracking-tight hover:text-text-secondary transition-colors">
              SilentLabs
            </Link>
          </div>

          {/* Right: Link Columns */}
          <div className="flex-1 flex flex-col md:flex-row gap-10 md:justify-between text-body md:text-sm">
            {/* Spacer for layout */}
            <div className="hidden md:block"></div>

            {/* Company */}
            <div className="flex flex-col gap-4 md:gap-6">
              <h3 className="text-text-secondary font-medium tracking-wide text-body md:text-sm">Company</h3>
              <div className="flex flex-col gap-4">
                <Link to="/research" className="text-text-primary hover:text-text-secondary transition-colors">Research</Link>
                <Link to="/about" className="text-text-primary hover:text-text-secondary transition-colors">About</Link>
                <Link to="/products" className="text-text-primary hover:text-text-secondary transition-colors">Products</Link>
              </div>
            </div>



            {/* Connect */}
            <div className="flex flex-col gap-4 md:gap-6">
              <h3 className="text-text-secondary font-medium tracking-wide text-body md:text-sm">Connect</h3>
              <div className="flex flex-col gap-4">
                <a href="https://x.com/SilentLabsAI" target="_blank" rel="noopener noreferrer" className="text-text-primary hover:text-text-secondary transition-colors">X (Twitter)</a>
                <button
                  onClick={() => setIsEmailModalOpen(true)}
                  className="text-text-primary hover:text-text-secondary transition-colors text-left"
                >
                  Email
                </button>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar Separator */}
        <div className="border-t border-border"></div>

        {/* Bottom Bar: Copyright vertically centered in symmetric 80px gap */}
        <div className="h-20 flex items-center justify-center md:justify-start text-body md:text-sm">
          <p className="text-text-secondary text-body md:text-sm text-center md:text-left">&copy; {new Date().getFullYear()} SilentLabs LLC</p>
        </div>
      </div>

      <EmailModal
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        email="cooperation@silentlabs.ai"
      />
    </footer>
  );
};

export default Footer;
